import React from 'react';

interface IAppsMenuIconProps {
  size?: number;
  fill?: string;
}

const AppsMenuIcon = ({ 
  size = 30, 
  fill = '#CE181E' 
}: IAppsMenuIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.5 8H8.5V4H4.5V8ZM10.5 20H14.5V16H10.5V20ZM4.5 20H8.5V16H4.5V20ZM4.5 14H8.5V10H4.5V14ZM10.5 14H14.5V10H10.5V14ZM16.5 4V8H20.5V4H16.5ZM10.5 8H14.5V4H10.5V8ZM16.5 14H20.5V10H16.5V14ZM16.5 20H20.5V16H16.5V20Z"
        fill={fill}
      />
    </svg>
  );
};

export default AppsMenuIcon;
